import { render } from "./S520_LieferantDokumentArchiv.vue?vue&type=template&id=cb38a5da&scoped=true&ts=true"
import script from "./S520_LieferantDokumentArchiv.vue?vue&type=script&lang=ts"
export * from "./S520_LieferantDokumentArchiv.vue?vue&type=script&lang=ts"

import "./S520_LieferantDokumentArchiv.vue?vue&type=style&index=0&id=cb38a5da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb38a5da"]])

export default __exports__